export class ActivityCondition {
  public id: string;
  public name: string;
  public description: string;
  public paragraph: string;
  public url: string;
  public typeId: string;
  public lawId: string;
}
